import React from "react";
import WalletTransactions from "./components/WalletTransactions";
import Wallet from "./components/WalletInfos";
import { TitleBar } from "../../../components/TitleBar";
import { useWallet } from "../../../hooks/useWallet";

interface WalletHistoryProps {
  
}

const WalletHistory: React.FC<WalletHistoryProps> = () => {
    const {nbTxUnread} = useWallet();

    return (
        <div className="flex-1 px-4 pt-8 overflow-hidden flex flex-col gap-8 overflow-y-auto">
            <TitleBar title="Wallet" badgeMobile={nbTxUnread} />
            <Wallet />
            <WalletTransactions />
        </div>
    );
}

export default WalletHistory;